package com.example.event_management_system.ui.components.event

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.example.event_management_system.data.models.EventStatus
import com.example.event_management_system.ui.theme.Dimens
import com.example.event_management_system.ui.theme.EventCancelled
import com.example.event_management_system.ui.theme.EventCompleted
import com.example.event_management_system.ui.theme.EventConfirmed
import com.example.event_management_system.ui.theme.EventPending
import com.example.event_management_system.ui.theme.statusColor

@Composable
fun EventStatusBadge(
    status: EventStatus,
    modifier: Modifier = Modifier,
    large: Boolean = false
) {
    val backgroundColor = when (status) {
        EventStatus.PENDING   -> EventPending
        EventStatus.CONFIRMED -> EventConfirmed
        EventStatus.COMPLETED -> EventCompleted
        EventStatus.CANCELLED -> EventCancelled
    }
    val textColor = status.statusColor
    val text = when (status) {
        EventStatus.PENDING   -> "Pending"
        EventStatus.CONFIRMED -> "Confirmed"
        EventStatus.COMPLETED -> "Completed"
        EventStatus.CANCELLED -> "Cancelled"
    }

    Box(
        modifier = modifier
            .clip(RoundedCornerShape(if (large) 8.dp else Dimens.cornerRadiusSmall))
            .background(backgroundColor)
            .padding(
                horizontal = if (large) Dimens.spacingLarge else Dimens.spacingSmall,
                vertical = if (large) Dimens.spacingSmall else Dimens.spacingXSmall
            )
    ) {
        Text(
            text = text,
            style = if (large) MaterialTheme.typography.titleSmall else MaterialTheme.typography.labelSmall,
            color = textColor
        )
    }
}
